export interface ShippingMethod {
  id: number;
  name: string;
  price: number;
  status: number;
  slug: string;
  discountedPrice: number;
}

export const shippingMethodFromResponse = (
  responseData: any,
): ShippingMethod => ({
  id: responseData.id,
  name: responseData.name,
  price: responseData.price.amount,
  status: responseData.status,
  slug: responseData.slug,
  discountedPrice: responseData.free_price.amount,
});
